var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPointsStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 39,
    viewBox: "0 0 64 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 25,
    width: 18,
    height: 13,
    rx: 5,
    fill: "#009595"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 16,
    width: 18,
    height: 22,
    rx: 5,
    fill: "#017373"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    width: 18,
    height: 39,
    rx: 5,
    fill: "#00959590"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPointsStatistics);
export default __webpack_public_path__ + "static/media/ic-points-statistics.7f59f2ef259e81c9ff006c3a6c4d564e.svg";
export { ForwardRef as ReactComponent };